// useKeyboardScroll.js
// On iOS, automatically scrolls focused input/textarea fields into view
// when the keyboard opens, so they aren't hidden behind it.

import { useEffect } from 'react';
import { Capacitor } from '@capacitor/core';
import { Keyboard } from '@capacitor/keyboard';

export function useKeyboardScroll() {
  useEffect(() => {
    if (!Capacitor.isNativePlatform()) return;

    let activeInput = null;

    const handleFocus = (e) => {
      const tag = e.target.tagName;
      if (tag === 'INPUT' || tag === 'TEXTAREA' || tag === 'SELECT') {
        activeInput = e.target;
      }
    };

    const handleBlur = () => {
      activeInput = null;
    };

    const scrollToActive = () => {
      if (!activeInput) return;
      // Delay to let the keyboard finish animating and the viewport settle
      setTimeout(() => {
        if (activeInput) {
          activeInput.scrollIntoView({ behavior: 'smooth', block: 'center' });
        }
      }, 300);
    };

    // Listen for focus on all inputs via event delegation
    document.addEventListener('focusin', handleFocus, true);
    document.addEventListener('focusout', handleBlur, true);

    // When the keyboard shows, scroll the active input into view
    const showListener = Keyboard.addListener('keyboardWillShow', scrollToActive);

    return () => {
      document.removeEventListener('focusin', handleFocus, true);
      document.removeEventListener('focusout', handleBlur, true);
      showListener.then((handle) => handle.remove());
    };
  }, []);
}